import { render, staticRenderFns } from "./OffCanvasDetailsLasku.vue?vue&type=template&id=159ef5a6&scoped=true&"
import script from "./OffCanvasDetailsLasku.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsLasku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ef5a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('159ef5a6')) {
      api.createRecord('159ef5a6', component.options)
    } else {
      api.reload('159ef5a6', component.options)
    }
    module.hot.accept("./OffCanvasDetailsLasku.vue?vue&type=template&id=159ef5a6&scoped=true&", function () {
      api.rerender('159ef5a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsLasku.vue"
export default component.exports